import styled from 'styled-components';
import FontSize from 'octa-front-sdk/dist/enums/FontSize';
import Color from 'octa-front-sdk/dist/enums/Color';

const ShiftsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: flex;
    justify-content: space-between;
    width: 60%;
    margin-bottom: 10px;

    span {
      font-size: ${FontSize.Small};
      color: ${Color.Grey700};
      flex: 1;

      &:last-of-type {
        flex: 2;
      }
    }
  }
`;

const Title = styled.h1`
  color: ${Color.Grey700};
  font-size: ${FontSize.Normal};
`;

const WorkHoursContentStyles = {
  ShiftsList,
  Title,
};

export default WorkHoursContentStyles;
